// client/src/locales/nl`

const nl = {
  translation: {
    404: {
      title: 'Sorry, we kunnen deze pagina niet vinden',
      description:
        'Het lijkt er op dat deze pagina niet (meer) bestaat of misschien is verhuisd. U kunt natuurlijk altijd op de <0>homepage</0> kijken.',
      link: '/'
    },
    cookiebar: {
      description:
        'Geef je BSL toestemming om cookies te plaatsen en te gebruiken? Je informatie zult gebruikt worden voor analytics.',
      accept: 'Ja, accepteer',
      decline: 'Nee',
      missing:
        'Je cookies moeten ingeschakeld zijn om deze video te bekijken. <0>Klik hier</0> om onze cookies te accepteren.'
    },
    header: {
      contact: 'Contact',
      menu: 'Menu',
      close_menu: 'Sluit'
    },
    footer: {
      change_privacy_settings: 'Verander privacy settings',
      about: {
        title: 'Over BSL',
        text:
          'We bring together radiologists, developers, scientists and hospitals to build Veye Chest which automatically detects, classifies and tracks the growth of pulmanory nodules.',
        url: '/over',
        label: 'Maak kennis'
      }
    },
    form: {
      step_button_text_next: "Volgende stap",
      step_button_text_prev: "Vorige stap",
      make_a_choice: "Selecteer een optie",
      multiple_answer_field_sample_text: "Meerdere antwoorden moeten gescheiden worden met een puntkomma er tussen. Voorbeeld: Antwoord1; Antwoord2; Antwoord3;",
      form_submit: "Verstuur",
      form_checked: "Ja",
      form_not_checked: "Nee",
      dep_filled: "Dit veld is verplicht",
      dep_email: "Vul een email in",
      dep_phone: "Vul een telefoonnummer in",
      notices: {
        success: {
          title: 'Uw bericht is verzonden.',
          text: 'We nemen zo snel mogelijk contact met u op.'
        },
        connection_error: 'Er ging iets bij het verbinden met de server. Probeer het later opnieuw.',
        other_error: 'Er ging iets fout. Probeer het later opnieuw.'
      },
      labels: {
        name: 'Naam',
        mail: 'E-mail',
        organization: 'Organisatie',
        job_title: 'Functietitel',
        message: 'Eventuele aanvullende opmerking',
        newsletter: 'Blijf op de hoogte van BSL via onze maandelijkse nieuwsbrief.',
        send: 'Verstuur formulier',
        optional: 'Optioneel'
      }
    },
    events: {
      sources: {
        nursing: 'Nursing',
        zorgvisie: 'Zorgvisie',
        kinderopvangtotaal: 'Kinderopvangtotaal',
        zorgwelzijn: 'Zorg+Welzijn',
        ggzcongressen: 'GGZ Congressen',
        tandartspraktijk: 'TandartsPraktijk',
        huisarts: 'Huisartsgeneeskunde',
        skipr: 'Skipr',
      }
    },
    pagination: {
      older: "Oudere items",
      newer: "Nieuwere items",
      earlier_events: "Eerdere events",
      later_events: "Latere events"
    },
    Tab1: {
      Title: "De organisatie",
      Q1: "In welke sector ben je actief? *",
      Q2: "Maakt jouw organisatie gebruik van een leermanagementsysteem (LMS)? *",
      Q3: "Hoeveel personen gaan er gebruik maken van de e-learningoplossing? *"
    },
    Tab2: {
      Title: "Aanvullende informatie",
      Q1: "Voor wie wil je de e-learning modules inzetten? *",
      Q1_All_Job_Functions: "Selecteer alle functies",
      Q2: "Welke thema's zijn voor jouw organisatie van belang? *",
      Q2_All_Themes: "Selecteer alle thema's",
      Q3: "Hoe zou de ideale verdeling van leren zijn?",
      Q4: "Hoe lang wil je de e-learning modules inzetten? *"
    },
    Tab3: {
      Title: "Huidige situatie",
      Q1: "Wie is de huidige leverancier van e-learning modules? *",
      Q2: "Wie is de huidige leverancier van het leermanagementsysteem (LMS)? *",
      Q3: "Over hoelang loopt het contract met de huidige leverancier af? *"
    },
    Tab4: {
      Title: "Jouw advies",
      Name: "Voornaam *",
      Prefix: "Tussenvoegsel",
      Surname: "Achternaam *",
      Job_Function: "Functie *",
      Organization: "Organisatie *",
      Phone: "Telefoonnummer *",
      Email: "E-mailadres *"
    },
    Beslismatrix: {
      Intro_Text: "Onze specialisten helpen je graag de leermiddelen te vinden die bij jouw organisatie passen. Met deze adviestool krijg je interessante leeroplossingen in beeld met een hoog leerrendement. Binnen 5 minuten heb je direct een vrijblijvend advies.",
      Title: "Advies op maat",
      Success_Text: "Bedankt voor de aanvraag.<br /><br /> Leuk dat je onze adviestool voor leeroplossingen hebt gebruikt. Onze leermiddelen adviseur gaat nu voor jou aan de slag en zal contact met je opnemen met een advies op maat.<br /><br /> Voor meer informatie wordt je naar de informatie pagina gestuurd...",
    }
  }
}

export default nl
